import gql from 'graphql-tag';
import fragments from '../fragments.js';

export default {
    campaignPost: gql`
        query CampaignPost($postID: String!) {
            campaignPost(postID: $postID) {
                ...PostWithSensitiveDataFragment
                ...PostWithSensitiveDataFullTranscriptsFragment
            }
        }
        ${fragments.postWithSensitiveData}
        ${fragments.postWithSensitiveDataFullTranscripts}
        ${fragments.image}
        ${fragments.audio}
    `,
};
